import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  section: ({ isOver }) => ({
    padding: theme.spacing(1),
    width: '300px',
    flexShrink: 0,
    border: '1px solid',
    borderColor: isOver ? '#d8dde1' : 'transparent',
    // background: '#00000005',
    borderRadius: '6px',
    minHeight: '430px',
    '&:has($header:hover)': {
      borderColor: '#d8dde1',
    },
  }),
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2.5),
  },
  headerField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  addTaskBtn: {
    color: 'inherit',
    opacity: 0.5,
    scale: 0.95,
    transition: 'all 0.3s ease',
    '&:hover': {
      scale: 1,
      opacity: 1,
      letterSpacing: '0.5px',
    },
  },
  titleBox: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    maxWidth: 'calc(100% - 80px)',
  },
  actionBox: {
    display: 'flex',
    gap: theme.spacing(0.5),
    '& > *': {
      borderRadius: '6px',
      padding: theme.spacing(0.5),
    },
  },
  taskStack: ({ isOver }) => ({
    background: isOver ? '#0000000f' : '#00000005',
    // height: '100%',
    borderRadius: '6px',
    // maxHeight: '350px',
    height: 'calc(100vh - 250px)',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
      opacity: 0, 
    },

    '&::-webkit-scrollbar-thumb': {
      background: '#b0b0b0',
      borderRadius: '10px',
    },
    scrollbarWidth: 'none',
    '&:hover::-webkit-scrollbar': {
      opacity: 1, 
      display: 'block',
    },
    '&:hover': {
      scrollbarWidth: 'thin', 
    },
  }),
}));
